"use client";

import { useCollectionContext } from "./VDHZ5F7K.js";
import { createElement, createHook, forwardRef } from "./LMDWO4NN.js";
import { useId, useMergeRefs } from "./ABQUS43J.js";
import { __objRest, __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/collection/collection-item.tsx
import { identity, removeUndefinedValues } from "@ariakit/core/utils/misc";
import { useEffect, useRef } from "react";
var TagName = "div";
var useCollectionItem = createHook(function useCollectionItem2(_a) {
  var _b = _a,
    store = _b.store,
    _b$shouldRegisterItem = _b.shouldRegisterItem,
    shouldRegisterItem = _b$shouldRegisterItem === void 0 ? true : _b$shouldRegisterItem,
    _b$getItem = _b.getItem,
    getItem = _b$getItem === void 0 ? identity : _b$getItem,
    element = _b.element,
    props = __objRest(_b, ["store", "shouldRegisterItem", "getItem",
    // @ts-expect-error This prop may come from a collection renderer.
    "element"]);
  var context = useCollectionContext();
  store = store || context;
  var id = useId(props.id);
  var ref = useRef(element);
  useEffect(function () {
    var element2 = ref.current;
    if (!id) return;
    if (!element2) return;
    if (!shouldRegisterItem) return;
    var item = getItem({
      id: id,
      element: element2
    });
    return store == null ? void 0 : store.renderItem(item);
  }, [id, shouldRegisterItem, getItem, store]);
  props = __spreadProps(__spreadValues({}, props), {
    ref: useMergeRefs(ref, props.ref)
  });
  return removeUndefinedValues(props);
});
var CollectionItem = forwardRef(function CollectionItem2(props) {
  var htmlProps = useCollectionItem(props);
  return createElement(TagName, htmlProps);
});
export { useCollectionItem, CollectionItem };